import { render, staticRenderFns } from "./FeatureUpdateDetails.vue?vue&type=template&id=54b33805&"
import script from "./FeatureUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./FeatureUpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports